export default "__VITE_ASSET__qy32apDH__"